import Tile, { TileProps } from "@hub/ui/cards/tile";
import React from "react";
import styles from "./builder-selection.module.css";

export interface BuilderSelectionProps {
  title: string;
  selectionData: TileProps;
  stepNumber: number;
}

export const BuilderSelection: React.FC<BuilderSelectionProps> = ({
  title,
  selectionData,
  stepNumber,
}) => {
  return (
    <div className={styles.builderSelection}>
      <h3 className={styles.builderSelection__headline}>
        <div className={styles.builderSelection__stepNumber}>{stepNumber}</div>
        <span className={styles.builderSelection__title}>{title}</span>
      </h3>
      <Tile {...selectionData} selected={true} />
    </div>
  );
};
